import { FC } from "react";
import { Row, Col } from "reactstrap";
import { Button } from "src/Components";
import getFieldComponent, { IFormProps } from ".";
import FormViewModel from "../Models/FormViewModel";
import BaseViewModel from "../Models/BaseViewModel";
import { DescriptorKeyType } from "../Types";
import { ReactComponent as DeleteIcon } from "src/Themes/assets/Delete.svg";
import st from "../DynamicForm.module.scss";

interface ICollectionItemProps extends Omit<IFormProps, 'model'> {
    model: FormViewModel;
    index: number;
    onRemove?: (index: number) => void;
    readOnly?: boolean;
};

const CollectionItem: FC<ICollectionItemProps> = ( props ) => {
    const { model, index, onRemove, readOnly = false, setFieldValue } = props;

    const renderInner = ( part: BaseViewModel, idx: number ) => {
        const Control = getFieldComponent( part.DescriptorKey as DescriptorKeyType );
        const readOnlyPart = readOnly || !part.ControlEnabling;
        return (
            <Col md={part.Width ?? 12} key={(part.LocalPath || part.Path || "") + "_" + idx}>
                <Control
                    model={part}
                    readOnly={readOnlyPart}
                    setFieldValue={setFieldValue}
                />
            </Col>
        );
    };

    return (
        <div className={st.collectionBlock_Form}>
            { !readOnly && (
                <Button outline variant="red" size="min" onClick={() => onRemove?.(index)} aria-label="Удалить элемент коллекции">
                    <DeleteIcon />
                </Button>
            )}
            <Row className={st.collectionBlock_Content}>
                { Array.isArray(model?.FormElements) && model.FormElements.map( renderInner ) }
            </Row>
        </div>
    );
};

export default CollectionItem;


